import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PerfilService } from 'src/app/service/perfil.service';
import { TarjetasService } from 'src/app/service/tarjetas.service';

@Component({
  selector: 'app-solicitud',
  templateUrl: './solicitud.component.html',
  styleUrls: ['./solicitud.component.scss']
})
export class SolicitudComponent implements OnInit {

  @Input() numCard: number
  @Input() nuevaSolicitud: boolean = false;
  @Output() closeModal = new EventEmitter<boolean>();

  error: any;
  modalError: any = false;
  loading = false;
  errorSolicitud: boolean;
  clasificaciones: any[];
  subclasificacion: any[];
  response: any
  session: any;
  dataRes: any;
  fechNaci: string = '';
  tituloSolicitud: string = 'Generar una solicitud';
  fechaAux = new Date()
  soliciExito: boolean = false;
  soliciExitoBlock: boolean = false;
  modalErrorBlock = ''
  loadingBlock = false;
  dni: string
  paso2: boolean = false;
  confirma: boolean = false;

  solicitudForm = new FormGroup({
    dni: new FormControl({ value: '', disabled: true }),
    nombres: new FormControl({ value: '', disabled: true }),
    apePaterno: new FormControl({ value: '', disabled: true }),
    apeMaterno: new FormControl({ value: '', disabled: true }),
    monto: new FormControl(0),
    direccion: new FormControl({ value: '', disabled: true }),
    tel: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }, Validators.email),
    sexo: new FormControl({ value: '', disabled: true }),
    date: new FormControl('', Validators.required),
    hora: new FormControl('', Validators.required),
    fnaci: new FormControl(),
    desc: new FormControl(),
    clasif: new FormControl(),
    numTarjetExt: new FormControl({ value: '', disabled: true }),
    subClasif: new FormControl()
  })

  descBloqueo: string = ''


  constructor(private tarjetas: TarjetasService, private perfil: PerfilService) {

    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi
    this.filterClassification()
    this.filterSubClassification()
  }


  ngOnInit(): void {

  }

  ngOnChanges(simple: { nuevaSolicitud: { currentValue: boolean } }) {
    if (simple.nuevaSolicitud?.currentValue) {
      this.loadPerfil()
    }
  }

  ngDoCheck() {
  }

  sendSolicitud() {
    this.error = false;
    this.modalError = ""
    if (this.solicitudForm.invalid) {
      this.error = true
    } else {
      this.loading = true;
      /*           if (this.tipoClasif == 'REPOS') {
              this.clasif = '00001';
              this.desclas = 'Personalizada';
              this.codSubClass = 'RS001';
            } */
      /*       if (this.tipoClasif == 'BLOLN') {
              this.clasif = this.sesion.bloqueos[this.bloqueo].numero;
              this.desclas = this.sesion.bloqueos[this.bloqueo].nombreBloqueo;
              this.codSubClass = 'BL001'
            } */
      const FormatDate = this.solicitudForm.get('date').value.split('-').join('') + this.solicitudForm.get('hora').value.split(':').join('') + '00';
      if (this.solicitudForm.get('clasif').value == '-1') {
        this.modalError = "Seleccione una clasificaciön"
        this.loading = false
        return
      }
      if (this.solicitudForm.get('subClasif').value == '-1') {
        this.modalError = "Seleccione una subclasificaciön"
        this.loading = false
        return
      }
      const body = {
        codClaseSolicitud: 'RECLA',
        desTipoSolicitud: 'Reclamo',
        codTipoSolicitud: 'RECLA',
        codAplicacion: 'POCAE',
        numEjecutivo: 3,
        nomResponsable: 'usuInternet',
        run: this.dni,
        tipoId: 'EXT',
        nombres: this.solicitudForm.get('nombres').value,
        apePaterno: this.solicitudForm.get('apePaterno').value,
        apeMaterno: this.solicitudForm.get('apeMaterno').value,
        email: this.solicitudForm.get('email').value,
        telefonoMovil: this.solicitudForm.get('tel').value,
        numTarjetaExtOrigen: this.numCard,
        direccion: this.solicitudForm.get('direccion').value,
        codTipoTarjetaOrigen: '',
        fhoIncidente: FormatDate,
        fecNacimiento: this.solicitudForm.get('fnaci').value,
        sexo: this.solicitudForm.get('sexo').value,
        desTipoTarjetaOrigen: 'Normal',
        codClasificacion: this.clasificaciones[this.solicitudForm.get('clasif').value].sCodParametro02,
        desClasificacion: this.clasificaciones[this.solicitudForm.get('clasif').value].sDesLargo01,
        codSubClasificacion: this.subclasificacion[this.solicitudForm.get('subClasif').value].sCodParametro03,
        desSubClasificacion: this.subclasificacion[this.solicitudForm.get('subClasif').value].sDesLargo01,
        montoSolicitado: this.solicitudForm.get('monto').value,
        glosaDescripcion: this.solicitudForm.get('desc').value,
        desEstado: this.solicitudForm.get('desc').value
      }
      this.tarjetas.sendData(body).subscribe(res => {
        this.response = res;

        if (this.response.nNumError != 0) {
          this.loading = false;
          this.modalError = this.response.sMsjError
        } else {
          this.paso2 = false;
          this.solicitudForm.reset()
          this.soliciExito = true;
          this.loading = false;
        }
      })
    }
  }

  next(response, tipo, titulo) {
    this.errorSolicitud = false;
    this.modalError = false
    this.solicitudForm.get('numTarjetExt').setValue(this.numCard)

    let date = new Date()
    let dateFormat = `${("0" + date.getDay()).slice(-2)}/${("0" + date.getMonth()).slice(-2)}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    if (tipo == 'BLOLN') {
      this.loadingBlock = true
      this.modalErrorBlock = ''
      let body = {

        "tipoMA": "TAG",
        "accion": "BLOQUEO",
        "fechaAccion": dateFormat,
        "idAplicativo": 7,
        "operadorApp": 156,
        "codMotivo": 0,
        "motivo": this.descBloqueo,
        "idma": localStorage.getItem('numInt')

      }

      this.tarjetas.bloqCard(body).subscribe(
        res => {

          if (res.estado == '0') {
            let body = {
              numEjecutivo: 3,
              run: this.dni,
              nombres: this.solicitudForm.get('nombres').value,
              apePaterno: this.solicitudForm.get('apePaterno').value,
              apeMaterno: this.solicitudForm.get('apeMaterno').value,
              email: this.solicitudForm.get('email').value,
              numTarjetaExtOrigen: this.numCard,
              nomResponsable: 'usuInternet',
              telefonoMovil: this.solicitudForm.get('tel').value,
              sexo: this.solicitudForm.get('sexo').value,
              fecNacimiento: this.solicitudForm.get('fnaci').value,
              glosaDescripcion: this.descBloqueo,
            }
            this.tarjetas.bloqCardPocae(body).subscribe(
              res => {
                this.soliciExitoBlock = true
                this.confirma = false
                this.loadingBlock = false;
                res.numError;
              },
              error => {
                this.loadingBlock = false;
                this.modalErrorBlock = "Error al enviar la solicitud de bloqueo.";
              }
            )
          } else {
            this.loadingBlock = false;
            this.modalErrorBlock = res.mensaje
          }
        }

      )
    } else {
      this.paso2 = response
      let json = {
        codTipoSolicitud: tipo,
        dni: this.dni,
        numTarjetaExtOrigen: this.numCard
      }
    }

  }
  filterClassification() {
    this.tarjetas.cargaParametrosSol().subscribe(res => {
      this.clasificaciones = res
      this.clasificaciones = this.clasificaciones.filter((cod) => {
        return cod.nNumParametro === 13075
      })
    })
  }
  filterSubClassification() {
    this.tarjetas.cargaParametrosSol().subscribe(res => {
      this.subclasificacion = res
      this.subclasificacion = this.subclasificacion.filter((cod) => {
        return cod.nNumParametro === 13076
      })
    })
  }


  solicitud(response: boolean) {
    this.error = false;
    this.errorSolicitud = false;
    this.loading = false
    this.nuevaSolicitud = response
    this.modalError = '';
    this.solicitudForm.reset();

    this.closeModal.emit(response)
    if (!response) {
      this.paso2 = false
      this.soliciExito = false;
      this.soliciExitoBlock = false
    }
  }
  loadPerfil() {
    let json = {
      KSI: this.session.ksi,
      idUsuarioWeb: this.session.idUsuario
    }
    this.perfil.loadUser(json).subscribe(res => {
      this.response = res;
      let month = this.response.fecNacimiento.month
      let day = this.response.fecNacimiento.day
      let formatDate = this.response.fecNacimiento.year + ("0" + month).slice(-2) + ("0" + day).slice(-2);
      this.solicitudForm.setValue({
        dni: this.dni,
        nombres: this.response.nombres,
        apePaterno: this.response.apePaterno,
        apeMaterno: this.response.apeMaterno,
        monto: 0,
        direccion: this.response.direccion,
        sexo: this.response.sexo,
        fnaci: formatDate,//`${this.response.fecNacimiento.year}${("0" + this.response.fecNacimiento.month.slice(-2))}${("0" + this.response.fecNacimiento.day.slice(-2))}`,
        desc: '',
        date: '',
        hora: '',
        clasif: '-1',
        subClasif: '-1',
        numTarjetExt: this.numCard,
        tel: this.response.telefono,
        email: this.response.correo,
      })

    })
  }

  onlyLetter(event) {
    let especiales = [225, 233, 237, 243, 250, 193, 201, 205, 211, 218, 228, 235, 239, 246, 252, 196, 203, 207, 214, 220]
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || especiales.includes(event.keyCode)) {
      return true
    }
    else {
      return false
    }
  }

  confirmar($event) {
    this.confirma = $event
    this.modalErrorBlock = '';
    this.descBloqueo = '';
  }

  cerrar() {
    this.solicitud(true)
    this.nuevaSolicitud = true;
    this.confirma = false
  }

  onlyNumber($event) {
    let key = $event.charCode;
    if (key <= 57 && key >= 48) {
      return true;
    } else {
      return false
    }
  }
}
